<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>平台建设</el-breadcrumb-item>
        <el-breadcrumb-item>配置管理</el-breadcrumb-item>
        <el-breadcrumb-item>自动派单设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="区域园区">
                <el-select clearable v-model="searchForm.idcpName" placeholder="请选择" @focus="handleSelectFocus">
                  <el-option v-for="(item, index) in campusOptions" :key="index" :label="Object.values(item)[0]"
                    :value="Object.values(item)[0]"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="账号类型">
                <el-select clearable v-model="searchForm.accountType" placeholder="请选择">
                  <el-option label="值班账号" value="值班账号"></el-option>
                  <el-option label="专项人员" value="专项人员"></el-option>
                  <el-option label="资产专项" value="资产专项"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="被派单人">
                <el-input v-model="searchForm.return_name" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="被派电话">
                <el-input v-model="searchForm.return_tel" placeholder="请输入电话"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="title-en">自动派单设置</div>
    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <div class="button-left">
            <el-button @click="handleAdd" type="primary">新增</el-button>
          </div>
          <div class="button-right">
            <el-button @click="openColumnsDialog">表头设置</el-button>
          </div>
        </div>

        <el-table :data="faults" border stripe @selection-change="handleSelectionChange" ref="table"
          v-loading="loading">
          <el-table-column v-for="(column, index) in visibleColumns" :key="index" :prop="column.prop"
            :label="column.label" :width="column.width" :align="column.align" :fixed="column.fixed">
            <template slot-scope="scope">
              <!-- 可编辑的 return_name 字段 -->
              <!-- 可编辑的 return_name 字段 -->
              <span v-if="column.prop === 'return_name'">
                <div @click="startEdit(scope.row, 'return_name')" class="editable-cell">
                  <span v-if="editingCell.rowId !== scope.row.id || editingCell.field !== 'return_name'"
                    class="editable-text">
                    {{ scope.row.return_name || '-' }}
                    <i class="el-icon-edit editable-icon"></i>
                  </span>
                  <el-input v-else v-model="scope.row.return_name" size="mini"
                    @blur="finishEdit(scope.row, 'return_name', scope.row.return_name)"
                    @keyup.enter.native="finishEdit(scope.row, 'return_name', scope.row.return_name)" autofocus
                    :data-row-id="scope.row.id" data-field="return_name" />
                </div>
              </span>

              <!-- 可编辑的 return_tel 字段 -->
              <span v-else-if="column.prop === 'return_tel'">
                <div @click="startEdit(scope.row, 'return_tel')" class="editable-cell">
                  <span v-if="editingCell.rowId !== scope.row.id || editingCell.field !== 'return_tel'"
                    class="editable-text">
                    {{ scope.row.return_tel || '-' }}
                    <i class="el-icon-edit editable-icon"></i>
                  </span>
                  <el-input v-else v-model="scope.row.return_tel" size="mini"
                    @blur="finishEdit(scope.row, 'return_tel', scope.row.return_tel)"
                    @keyup.enter.native="finishEdit(scope.row, 'return_tel', scope.row.return_tel)" autofocus
                    :data-row-id="scope.row.id" data-field="return_tel" />
                </div>
              </span>

              <!-- 操作列 -->
              <span v-else-if="column.prop === 'operation'">
                <el-button type="text" size="small" @click="handleViewDetail(scope.row)">查看详情</el-button>
              </span>

              <!-- 其他字段 -->
              <span v-else>{{ scope.row[column.prop] || '-' }}</span>
            </template>
          </el-table-column>

        </el-table>

        <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" :append-to-body="true" width="400px"
          :close-on-click-modal="false" custom-class="columns-dialog" :modal-append-to-body="false"
          :destroy-on-close="true">
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>
        <el-dialog title="新增自动派单账号" :visible.sync="addDialogVisible" width="500px" :append-to-body="true">
          <el-form :model="addForm" label-width="200px">
            <el-form-item label="园区一级机房名称" prop="return_name">
              <el-input v-model="addForm.idcpName" placeholder="请输入带后缀名称园区idcpName"></el-input>
            </el-form-item>
            <el-form-item label="账号类型" prop="accountType">
              <el-select v-model="addForm.accountType" placeholder="请选择账号类型" style="width: 100%">
                <el-option v-for="item in accountTypeOptions" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="被派单人" prop="return_name">
              <el-input v-model="addForm.return_name" placeholder="请输入被派单人姓名"></el-input>
            </el-form-item>
            <el-form-item label="被派电话" prop="return_tel">
              <el-input v-model="addForm.return_tel" placeholder="请输入被派电话"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelAddForm">取消</el-button>
            <el-button type="primary" @click="submitAddForm">确定</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getAutoDispatchUser, updateAutoDispatchUser, addAutoDispatchUser } from '@/api/auto_dispatch';
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';
import { getCampusList } from '@/api/operation';
export default {
  name: 'FaultList',
  data() {
    return {
      showColumnsDialog: false,
      campusOptions: [], // 用于存储园区接口返回的数据
      hasLoaded: false, // 添加标志位防止重复加载
      columns: [
        { prop: 'id', label: 'id', width: 50 },
        { prop: 'idcpName', label: '园区名字' },
        { prop: 'accountType', label: '账号类型' },
        { prop: 'return_name', label: '名字' },
        { prop: 'return_tel', label: '电话' },

      ],
      selectedColumns: [
        'id',
        'idcpName',
        'accountType',
        'return_name',
        'return_tel',

      ],
      defaultSelectedColumns: [
        'id',
        'idcpName',
        'accountType',
        'return_name',
        'return_tel',
      ],
      visibleColumns: [],
      selectedRows: [],
      faults: [],
      searchForm: {
        id: null,
        idcpName: "",
        accountType: "",
        return_name: "",
        return_tel: "",
        export_excel: "0"
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      editingCell: {
        rowId: null,
        field: null
      },
      addDialogVisible: false,
      addForm: {
        idcpName: '',
        accountType: '',
        return_name: '',
        return_tel: ''
      },
      accountTypeOptions: [
        { label: '值班账号', value: '值班账号' },
        { label: '专项人员', value: '专项人员' },
        { label: '资产专项', value: '资产专项' },
      ]
    };
  },
  created() {

    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    this.searchForm.finishedTime = [
      this.$moment(startDate).format('YYYY-MM-DD'),
      this.$moment(endDate).format('YYYY-MM-DD'),
    ];
    this.handleDateChange(this.searchForm.finishedTime);
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    // 初始化园区数据
    this.getCampusData();
    this.fetchFaultData();
    // 创建防抖后的导出函数
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    // 新增账号
    handleAdd() {
      // 重置表单数据
      this.addForm = {
        idcpName: '',
        accountType: '',
        return_name: '',
        return_tel: ''
      };
      this.addDialogVisible = true;
    },

    // 提交新增表单
    submitAddForm() {
      // 先显示确认提示框
      this.$confirm('提交后仅能联系管理员删除，请再次确认', '确认新增', {
        confirmButtonText: '提交',
        cancelButtonText: '再次确认',
        type: 'warning'
      }).then(() => {
        // 用户确认后执行新增操作
        this.addForm.username = localStorage.getItem('UserId');
        addAutoDispatchUser(this.addForm).then(response => {
          if (response.data.code === 200) {
            this.$message.success('新增成功');
            this.addDialogVisible = false;
            this.fetchFaultData(); // 重新加载数据
          } else {
            this.$message.error(response.data.msg || '新增失败');
          }
        }).catch(error => {
          this.$message.error('新增失败');
          console.error(error);
        });
      }).catch(() => {
        // 用户取消操作
        console.log('用户取消新增操作');
      });
    },

    // 取消新增
    cancelAddForm() {
      this.addDialogVisible = false;
    },
    //园区获取数据接口
    async getCampusData() {
      try {
        const params = {
          spec_sign: 1,
        };
        const response = await getCampusList(params);
        if (response.data && response.data.code === 200) {
          this.campusOptions = response.data.data;
          this.hasLoaded = true;
          //console.log("成功设置 campusOptions:", this.campusOptions)
        } else {
          console.warn("接口返回状态码不正确:", response.data?.code)
        }
      } catch (error) {
        console.error('获取园区数据失败:', error);
      }
    },

    // focus 事件处理园区获取数据
    handleSelectFocus() {
      if (!this.hasLoaded) {
        this.getCampusData();
      }
    },
    handleDateChange(val) {
      if (val) {
        this.searchForm.start_time = val[0];
        this.searchForm.end_time = val[1] + ' 23:59:59';
      } else {
        this.searchForm.start_time = startDate;
        this.searchForm.end_time = endDate;
      }
    },
    fetchFaultData() {
      this.loading = true;
      const params = {
        page: this.currentPage,
        size: this.pageSize,
        ...this.searchForm,
      };
      delete params.finishedTime;

      getAutoDispatchUser(params)
        .then((res) => {
          if (res.data.code === 200) {
            // 保存原始值以便后续比较
            this.faults = (res.data.data || []).map(item => {
              return {
                ...item,
                _original_return_name: item.return_name,
                _original_return_tel: item.return_tel
              };
            });
            this.total = res.data.total || 0;
          } else {
            this.$message.error(res.msg || '获取列表失败');
          }
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.$message.error('获取列表失败');
          this.loading = false;
        });
    },
    // 开始编辑
    startEdit(row, field) {
      this.editingCell = {
        rowId: row.id,
        field: field
      };
      // 使用 nextTick 确保 DOM 更新后再聚焦
      this.$nextTick(() => {
        // 获取输入框元素并聚焦
        const input = document.querySelector(`input[data-row-id="${row.id}"][data-field="${field}"]`);
        if (input) {
          input.focus();
        }
      });
    },
    // 完成编辑并确认更新
    async finishEdit(row, field, newValue) {
      // 保存原始值
      const oldValue = field === 'return_name' ? row._original_return_name : row._original_return_tel;

      // 退出编辑状态
      this.editingCell = {
        rowId: null,
        field: null
      };

      // 如果值没有改变，直接返回
      if (newValue === oldValue) {
        return;
      }

      // 显示确认对话框
      const fieldLabel = field === 'return_name' ? '被派单人' : '被派电话';

      try {
        await this.$confirm(
          `确定要修改${fieldLabel}吗？<br><br>原内容：${oldValue || '空'}<br>新内容：${newValue || '空'}`,
          '确认修改',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        );

        // 用户确认后执行更新
        const params = {
          id: row.id,
          [field]: newValue,
          username: localStorage.getItem('UserId')
        };

        const response = await updateAutoDispatchUser(params);

        if (response.data.code === 200) {
          this.$message.success('更新成功');
          // 更新原始值
          row[`_original_${field}`] = newValue;
          // 重新加载数据
          this.fetchFaultData();
        } else {
          this.$message.error(response.data.msg || '更新失败');
          // 恢复原始值
          row[field] = oldValue;
        }
      } catch (error) {
        // 用户取消或更新失败，恢复原始值
        row[field] = oldValue;
        console.log('用户取消修改或更新失败');
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleReset() {
      this.searchForm = {
        id: null,
        idcpName: "",
        accountType: "",
        return_name: "",
        return_tel: "",
        export_excel: "0"
      };
      this.currentPage = 1;
      this.fetchFaultData();
    },

    async handleExport() {
      if (this.exportLoading) return;
      this.exportLoading = true;

      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          const params = {
            ...Object.fromEntries(
              Object.entries(this.searchForm).filter(
                ([key, value]) =>
                  value !== '' && value !== null && value !== undefined && key !== 'finishedTime'
              )
            ),
          };

          params.export_excel = "1";

          // 正确等待API响应
          const response = await getAutoDispatchUser(params);

          if (response && response.data && response.data.code === 200) {
            const allData = response.data.data || [];

            if (allData.length === 0) {
              this.$message.warning('没有数据可导出');
              return;
            }

            // 处理并导出数据...
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.columns.forEach((column) => {
                if (column.prop !== 'operation') {
                  let value = row[column.prop];
                  if (column.prop === 'finished_time' && value) {
                    value = this.$moment(value).format('YYYY-MM-DD HH:mm:ss');
                  }
                  rowData[column.label] = value || '-';
                }
              });
              return rowData;
            });

            // 创建并导出Excel文件...

            const sheetName = '自动派单数据列表';
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `自动派单数据列表_${timestamp}.xlsx`;
            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          } else {
            this.$message.error(response.data.msg || '导出失败');
          }
        }
        // ...处理选中行导出的逻辑
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
      }
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchFaultData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchFaultData();
    },
    handleViewDetail(row) {
      window.open(
        `https://dcops.fre.tencent-cloud.com/appManage/tickets/details?params=${row.opTicketid}`,
        '_blank'
      );
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
};
</script>

<style scoped>
.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.button-left {
  flex: 1;
}

.button-right {
  flex-shrink: 0;
}

/* 可编辑单元格样式 */
.editable-cell {
  position: relative;
  cursor: pointer;
  min-height: 23px;
  padding: 2px 0;
}

.editable-text {
  position: relative;
  display: inline-block;
  padding: 2px 4px;
  border-radius: 2px;
  transition: all 0.3s;
  color: #409eff;
  /* 设置字体为蓝色 */
}

.editable-text:hover {
  background-color: #f0f8ff;
  border: 1px dashed #409eff;
  box-shadow: 0 0 2px #409eff;
}

.editable-icon {
  margin-left: 5px;
  font-size: 12px;
  color: #409eff;
  opacity: 0;
  transition: opacity 0.3s;
}

.editable-text:hover .editable-icon {
  opacity: 1;
}

/* 编辑状态下的输入框样式 */
.editable-cell .el-input__inner {
  border: 1px solid #409eff;
  box-shadow: 0 0 2px #409eff;
}

/* 确保文本垂直居中 */
.editable-cell .el-input {
  vertical-align: middle;
}

.container {
  padding: 20px;
  min-height: 500px;
  /* 确保容器有最小高度 */
}

/* .container {
  padding: 20px;
} */

.ellipsis-text {
  display: inline-block;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 10px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button+.el-button {
  margin-left: 8px;
}

/* PO单号链接样式 */
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}

::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}

/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}

::v-deep .el-form-item__content {
  width: calc(100% - 30px) !important;
}

::v-deep .el-dialog .el-form-item__content {
  margin-left: 20px !important; /* 与 label-width 保持一致 */
}
::v-deep .el-dialog .el-form-item__label {
  text-align: left !important;
}
</style>
